import { render, staticRenderFns } from "./buyPacketModal.vue?vue&type=template&id=31c0a499&scoped=true&"
import script from "./buyPacketModal.vue?vue&type=script&lang=js&"
export * from "./buyPacketModal.vue?vue&type=script&lang=js&"
import style0 from "./buyPacketModal.vue?vue&type=style&index=0&id=31c0a499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c0a499",
  null
  
)

export default component.exports